export enum Permission {
  EnterpriseStatusPageView = 'enterprise_status_page.view',
  RetailerContactManagementView = 'retailer_contact_management.view',
  CaperBillingView = 'caper_billing.view',
  CaperBillingModify = 'caper_billing.modify',
}
